import { useOuterClick } from './useOuterClick';

export default useOuterClick;
